/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientSessionModel } from '../../models/patient-session-model';

export interface GetPatientSessionWithData$Params {
  sessionID?: number;
}

export function GetPatientSessionWithData(http: HttpClient, rootUrl: string, params?: GetPatientSessionWithData$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientSessionModel>> {
  const rb = new RequestBuilder(rootUrl, GetPatientSessionWithData.PATH, 'get');
  if (params) {
    rb.query('sessionID', params.sessionID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientSessionModel>;
    })
  );
}

GetPatientSessionWithData.PATH = '/api/Staff/GetPatientSessionWithData';
